import { useUserEventLogger } from '@repo/tracking-service';
import { Badge, List, SubTitle, Svg } from '@repo/ui';
import { useRouter } from 'next/router';

import s from '@/components/menu/menu.module.scss';
import { INVITE_PROMOTION_PATH } from '@/lib/constants/link';

export const EventSection = () => {
  const router = useRouter();
  const { sendClickEvent } = useUserEventLogger();

  const goInviteFriendPage = () => {
    sendClickEvent('more_body_promo', {
      item: 'invite-promo'
    });

    router.push(INVITE_PROMOTION_PATH);
  };

  return (
    <li>
      <SubTitle title={'진행중인 이벤트'} size={'medium'} className={s.menu_list_padding} />
      <ul>
        <li className={s.menu_list_padding}>
          <List
            title={
              <div className={'flex items-center gap-x-tiny-medium'}>
                <p>{'친구초대 이벤트'}</p>
                <Badge label={'EVENT'} variant={'promo'} />
              </div>
            }
            leadingElement={<img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/icons/fill-giftbox-rd-rg.svg`} alt={'선물상자'} width={32} height={32} />}
            supportingElement={<Svg src={'ic_chevron-right.svg'} width={20} height={20} color={'#8A96A3'} />}
            primaryAction={true}
            onClick={goInviteFriendPage}
          />
        </li>
      </ul>
    </li>
  );
};
